import React from "react";

function SubscribersLoaderView({
  props,
  rawData,
  setRawData,
  header = [],
  subscribersTemplate,
  subscribers,
  isLoading,
  downloadIndex,
  sendData,
  onCheckAll,
}) {
  return (
    <div className="row row-sm subscribers-loader">
      <div>
        <button
          className="btn btn-az-primary"
          style={{ position: "absolute", left: "4px" }}
          onClick={(e) => {
            props.handleLoader();
          }}
        >
          <i className="fas fa-arrow-left"></i> Volver
        </button>

        <h3>Cargador masivo de Suscriptores</h3>
        <p>
          Copia y pega desde una hoja de calculo (El separador de columnas
          deberá ser un tabulado) en el siguiente orden:{" "}
          <strong>
            {header.map((head, index) => {
              if (index > 0) {
                return <span key={head.index}>{head.label}, </span>;
              }
              return null;
            })}
          </strong>
        </p>
        <textarea
          value={rawData}
          onChange={(e) => {
            setRawData(e.target.value);
          }}
        />
      </div>
      <div className="subscribers-table">
        <div className="subscribers-table-actions">
          <button className="btn btn-az-primary" onClick={onCheckAll}>
            Marcar todos
          </button>
          <button
            className="btn btn-info mg-l-20"
            onClick={() => onCheckAll({ check: false })}
          >
            Desmarcar todos
          </button>
        </div>
        <table>
          <thead>
            <tr>
              {header.map((head, index) => {
                return <th key={head.index}>{head.label}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {subscribers.map((row, index) => {
              return (
                <tr key={index}>
                  <td>
                    <label className="ckbox">
                      <input
                        type="checkbox"
                        className="subscribers-loader-notify"
                        onChange={(e) => {}}
                      />{" "}
                      <span></span>
                    </label>
                  </td>
                  {header.map((field, index2) => {
                    if (index2 > 0) {
                      return (
                        <td key={`${index}_${field.index}_${index2}`}>
                          {row[field.index] || ""}
                        </td>
                      );
                    }
                    return null;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {subscribers.length > 0 && (
        <button
          className="btn btn-az-primary algo"
          style={{ position: "absolute", bottom: "3.5em", right: "3em" }}
          disabled={isLoading}
          onClick={sendData}
        >
          <i
            className={isLoading ? "fas fa-spinner fa-spin" : "fas fa-upload"}
          ></i>{" "}
          Carga{isLoading ? `ndo ${downloadIndex} de ` : "r"}{" "}
          {subscribers.length} registro{subscribers.length > 1 ? "s" : ""}
        </button>
      )}
    </div>
  );
}

export default SubscribersLoaderView;
